var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFaqs2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 61,
    stroke: "#339999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.2395 52.2388H56.8263C53.9508 52.2388 51.6198 54.513 51.6198 57.3184V67.4776C51.6198 70.283 53.9508 72.5572 56.8263 72.5572H67.2395C70.115 72.5572 72.4461 70.283 72.4461 67.4776V57.3184C72.4461 54.513 70.115 52.2388 67.2395 52.2388Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2066 57.3184C39.8257 57.3184 38.5014 56.7832 37.525 55.8306C36.5485 54.878 36 53.586 36 52.2388V42.0796C36 40.7324 36.5485 39.4404 37.525 38.4878C38.5014 37.5352 39.8257 37 41.2066 37H51.6198C53.0006 37 54.325 37.5352 55.3014 38.4878C56.2778 39.4404 56.8264 40.7324 56.8264 42.0796",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2395 82.7163C67.2395 84.0635 67.7881 85.3556 68.7645 86.3082C69.7409 87.2608 71.0652 87.7959 72.4461 87.7959H82.8593C84.2401 87.7959 85.5645 87.2608 86.5409 86.3082C87.5173 85.3556 88.0659 84.0635 88.0659 82.7163V72.5571C88.0659 71.2099 87.5173 69.9179 86.5409 68.9653C85.5645 68.0127 84.2401 67.4775 82.8593 67.4775",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs2);
export default __webpack_public_path__ + "static/media/IconFaqs2.c2c740e13bbb4d621a2241f18979fb4c.svg";
export { ForwardRef as ReactComponent };